import React, { useState } from 'react';
import './Promotion.css';
import { useDispatch } from 'react-redux';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { PromotionText } from './PromotionText';
import { TermsModal } from '../../TermsModal';
import { AppService } from '../../../../../shared/src/services/app.service';
import { AppActionEnum } from '../../../../../shared/src/enums/app-action.enum';

export const Promotion = ({ image, url, essentialText, badge, title, subtitle, isLanding, fullText }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslations();

    const handleToggleModal = () => setIsModalOpen(prev => !prev);
    const openPromotion = () => AppService.ctaHandler(AppActionEnum.GOTO, url, dispatch);
    const openRegistration = () => AppService.ctaHandler(AppActionEnum.REGISTRATION, null, dispatch);

    const handlePromotionClick = isLanding ? openRegistration : openPromotion;
    const handleCtaClick = isLanding ? handleToggleModal : openPromotion;

    return (<div className="promotion-item-container">
        <div className="promotion-item-image" onClick={handlePromotionClick}>
            <img src={image} alt="Image" loading="lazy" className="promotion-item-image__picture"/>
            <div className="promotion-item-image__badge">{badge}</div>
        </div>

        <PromotionText text={title} className="promotion-item-title" onClick={handlePromotionClick} />

        <PromotionText text={subtitle} className="promotion-item-subtitle" onClick={handlePromotionClick} />

        {essentialText && <div className="promotion-item-terms">
            <div className="promotion-item-terms__title">{t('termsAndConditionsPROMOTION')}</div>
            <div className="promotion-item-terms__container">
                <span
                    className="promotion-item-terms__text"
                    dangerouslySetInnerHTML={{ __html: `${essentialText}... ` }}>
                </span>
                <a onClick={handleCtaClick} className="promotion-item-terms__readMore">{t('readMore')}</a>
            </div>
        </div>}

        {isModalOpen &&
            <TermsModal handleToggleModal={handleToggleModal} fullTnC={fullText} isModalOpen={isModalOpen} />}
    </div>);
};
